<template>
  <div class="invite__btn">
    <div id="creatImgBefore" v-show="creatImgBeforeshow">
      <img id="bgimg" :src="basicInfo.shareImg" crossorigin="anonymous" alt />
      <div id="qrcode"></div>
    </div>
    <div class="invite__btn-fix">
      <div class="btn" @click="handleInvite">立即邀请</div>
    </div>
    <van-overlay :show="canvasImgShow" @click="canvasImgShow = false">
      <div class="account__share" @click.stop>
        <img class="userImg" :src="dataUrl" alt />
        <p class="tips">长按保存图片</p>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import loadJS from 'load-js';
import html2canvas from 'html2canvas';
import { reqAgentKey } from '@/api/invitationCommission';

export default {
  props: {
    basicInfo: {
      type: Object,
    },
    accountInfo: {
      type: Object,
    },
  },
  data() {
    return {
      agentId: '',
      dataUrl: null,
      canvasImgShow: false,
      creatImgBeforeshow: false,
      isCreateCanvas: false, // 生成canvas防止多次点击
      isCreatQrCode: false, // 生成二维码防止多次点击
    };
  },
  methods: {
    createImg() {
      this.creatImgBeforeshow = true;
      if (this.dataUrl) {
        this.showShare();
        return;
      }
      loadJS([
        {
          async: false,
          url: 'https://image-prod.iqihang.com/public/js/qrcode.min.js',
        },
      ]).then(() => {
        this.creatQrCode();
        setTimeout(() => {
          this.createCanvas();
        }, 500);
      });
    },
    creatQrCode() {
      if (this.isCreatQrCode) return;
      this.isCreatQrCode = true;
      const url = `${window.location.origin}/ark/invitation/friendTransfer?agentId=${this.agentId}`;
      console.log('创建二维码', url);
      const clientWidth = document.getElementById('qrcode').offsetWidth;
      // eslint-disable-next-line no-new, no-undef
      new QRCode(document.getElementById('qrcode'), {
        text: url,
        render: 'table',
        // render:"canvas",
        width: clientWidth,
        height: clientWidth,
        typeNumber: -1, // 计算模式
        correctLevel: 0, // 纠错等级   correctLevel
      });
      console.log('创建二维码成功了', document.getElementById('qrcode'));
      setTimeout(() => {
        this.isCreatQrCode = false;
      }, 2000);
    },
    createCanvas() {
      if (this.isCreateCanvas) return;
      this.isCreateCanvas = true;
      html2canvas(document.getElementById('creatImgBefore'), {
        dpi: 300,
        useCORS: true,
        backgroundColor: 'transparent', // 圆角问题
      }).then((canvas) => {
        this.imgBeforeShow = false;
        const dataURL = canvas.toDataURL('image/png', 1.0);
        this.dataUrl = dataURL;
        this.$toast.clear();
        this.creatImgBeforeshow = false;
        this.showShare();
      });
      setTimeout(() => {
        this.isCreateCanvas = false;
      }, 2000);
    },
    handleInvite() {
      this.$toast.loading({
        message: '图片生成中...',
        forbidClick: true,
        duration: 0,
      });
      if (!this.agentId) {
        reqAgentKey().then((res) => {
          if (res.code === 0) {
            this.agentId = res.data;
            this.$nextTick(() => {
              this.createImg();
            });
          }
        });
      } else {
        this.createImg();
      }
    },
    // 调用app原生方法
    showShare() {
      this.$toast.clear();
      if (this.$root.isApp) {
        const url = `${window.location.origin}/ark/invitation/friendTransfer?agentId=${this.agentId}`;
        this.$sendToApp(
          'shareStudyReport',
          {
            url: this.dataUrl,
            copyLink: url,
          },
          false,
        );
      } else {
        this.canvasImgShow = true;
      }
    },
  },
  watch: {
    accountInfo: {
      immediate: true,
      deep: true,
      async handler(value) {
        if (value?.id) {
          this.agentId = value.id;
        }
      },
    },
  },
};
</script>
<style scoped lang="scss">
#creatImgBefore {
  position: fixed;
  top: 100px;
  top: 50%;
  left: 0;
  left: 50%;
  z-index: -2;
  width: 678px;
  height: 1069px;
  background: #E5E8F1;
  border-radius: 18px;
  transform: translate(-50%, -50%);

  #bgimg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  #qrcode {
    position: absolute;
    bottom: 58px;
    left: 434px;
    z-index: 1;
    width: 145px;
    height: 145px;

    canvas,
    img {
      width: 100% !important;
      height: 100% !important;
    }
  }
}

.creatImgAfter {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);

  .canvasImg {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 600px;
    height: 1000px;
    transform: translate(-50%, -50%);

    .guideImg {
      width: 598px;
      height: 142px;
    }

    .close {
      position: absolute;
      top: 24px;
      right: 24px;
      width: 48px;
      height: 48px;
    }

    .tips {
      width: 600px;
      width: fit-content;
      height: 64px;
      margin: 58px auto 0;
      color: #fff;
      font-size: 24px;
      line-height: 64px;
      text-align: center;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 16px;
    }
  }

  .canvasImgInMINI {
    top: 0;
    transform: translate(-50%, 0);

    .close {
      position: absolute;
      top: 70px;
      right: 38px;
      width: 126px;
      height: 50px;
    }
  }
}

.invite__btn {
  .account__share {
    position: absolute;
    width: 600px;

    .userImg {
      width: 100%;
      height: 100%;
      border-radius: 16px;
    }

    .tips {
      height: 40px;
      margin-top: 58px;
      color: #fff;
      font-weight: 400;
      font-size: 29px;
      font-style: normal;
      line-height: 40px;
      text-align: center;
    }
  }
}

.invite__btn-fix {
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: center;
  width: 750px;
  height: 167px;
  background: #FFF;
  border-radius: 22px 22px 2px 2px;
  box-shadow: 0 -4 14px 0 rgba(0, 0, 0, 0.05);

  .btn {
    width: 678px;
    height: 80px;
    margin-top: 22px;
    color: #FFF;
    font-weight: 500;
    font-size: 29px;
    font-style: normal;
    line-height: 80px;
    text-align: center;
    background: #FF7F41;
    border-radius: 49px;
  }
}
</style>
